import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FinalFare from "../finalfare/finalFare";
import StartEndTrip from "../../../components/comment/startendtrip/startEndTrip";
import MainFeature from "../../../components/comment/carfeature/mainFeature";
import marutibreeza from "../../../assets/images/maruti-breeza.png";
import BookedCar from "../../../components/comment/bookedcar/bookedCar";

const fareSummaryContent = () => {
  return (
    <section className="fare-summary-content pt-4 pb-5 ">
      <Container>
        <div className=" verification-wrap">
          <Row>
            <Col lg={4} className="px-0">
              <div className="summary-left-wrap">
                <div className="summary-title">Checkout Summary</div>
                <FinalFare />
              </div>
            </Col>

            <Col lg={8} className="px-0">
              <div className="summary-right-wrap">
                <div className="summary-title">Booking Details</div>
                <div className="start-end-status">
                  <StartEndTrip />
                </div>

                <Row>
                  <Col md={6}>
                    <div className="booked-car-image">
                      <div className="car-image ">
                        <BookedCar img={marutibreeza} />
                      </div>
                    </div>
                  </Col>
                  <Col md={6} className="d-flex align-items-center justify-content-center">
                    <div className="main-feature  ">
                      <MainFeature />
                    </div>
                  </Col>
                </Row>

                <Row className="p-3 px-4">
                 
                  <Col md={12}>
                    <div className="fare-detail">
                      <p>
                        You will get a clean and sanitized car. Exact car
                        location will be shared post-booking
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default fareSummaryContent;
